module.exports = __webpack_public_path__ + "static/media/error.54d8d029.png";